import { API_BASE_URL, FAILURE, GET, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function verifyLogin(usuario, contrasenia) {
    try {
        let data = { error: true };
        const { status, body, message } = await fetch(
            API_BASE_URL + "usuario-web/login-web",
            {
                headers: {
                    "Content-Type": "application/json",
                },
                method: POST,
                body: JSON.stringify({ username: usuario, password: contrasenia }),
            }
        ).then((res) => res.json());
        // console.log('status');
        // console.log(status);
        // console.log('body');
        // console.log(body);
        if (status === SUCCESS) {
            data.error = false;
            data.body = body;
        } else {
            data.error = true;
            data.message = message;
            data.body = null;
        }
        // console.log('data');
        // console.log(data);
        return data;
    } catch (err) {
        console.log("verifyLogin err");
        console.log(err);
        return { error: true };
    }
}

export async function obtenerInfoUsuario() {
    try {
        let data = { error: true, body: null };
        const { code, message, body } = await fetch(
            API_BASE_URL + "usuario-web/obtener-info-usuario",
            {
                headers: getHeaders(),
                method: GET,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerInfoUsuario err");
        console.log(err);
        return { error: true, message: err };
    }
}